/*
 * Wraps one sign-in option and marks it "Last used" when it is the way this
 * device last signed in (services/lastSignInMethod, GUARDRAILS G1).
 */
import React from 'react';
import styles from './LastUsedBadge.module.css';
import type { SignInMethod } from '../../services/lastSignInMethod';

interface Props {
  method: SignInMethod;
  last: SignInMethod | null;
  children: React.ReactNode;
}

const LastUsedOption: React.FC<Props> = ({ method, last, children }) => (
  <div className={styles.option}>
    {children}
    {last === method && <span className={styles.badge}>Last used</span>}
  </div>
);

export default LastUsedOption;
